import { setCommunityData } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetCommunities } from "@/services";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const useManageBOM = () => {
  const dispatch = useDispatch();
  const [communityId, setCommunityId] = useState("");
  const [communityKey, setCommunityKey] = useState(Math.random() * 2);

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const { data: communityList, isLoading: isCommunityLoading } =
    useGetCommunities({
      queryParams: {
        staleTime: 0,
        refetchOnMount: "always",
      },
    });

  useEffect(() => {
    if (!communityList?.data) return;
    const selected = communityDetail?.communityId
      ? communityList.data.find(
          (data: any) => data.communityId == communityDetail.communityId
        )
      : communityList.data[0];
    if (!selected) return;
    setCommunityId(selected.communityId);
    dispatch(setCommunityData(selected));
    setCommunityKey(Math.random() * 2);
  }, [communityList]);

  const onCommunityChange = (e: any) => {
    setCommunityId(e);
    const details = communityList?.data?.find(
      (data: any) => data.communityId == e
    );
    dispatch(setCommunityData(details));
  };

  return {
    onCommunityChange,
    isCommunityLoading,
    communityId,
    communityKey,
    communityDetail,
    communityList,
  };
};

export default useManageBOM;
